import moment from "moment";
import { remove } from "lodash";

import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess,
  sagaSearchSuccess
} from "../actions/ActionTypes";
import { timestampSorter } from "../utils/Sorters";
const MEDITATIONS = "meditations";
const MEDITATION = "meditation";
const currentMeditation = {
  start_week_date: moment(),
  title: "",
  content: "",
  id: 0
};
const initialState = { list: [], currentMeditation, searching: false };
export default function meditations(state = initialState, action = {}) {
  switch (action.type) {
    case "FIND_MEDITATION":
      const med = state.list.find(x => x.id === action.id);
      return { ...state, currentMeditation: med };
    case sagaListSuccess(MEDITATIONS):
      const meditations = action.data.data;
      return { ...state, list: meditations.sort(timestampSorter) };
    case sagaOneSuccess(MEDITATION):
      return { ...state, currentMeditation: action.data.data };
    case sagaCreateSuccess(MEDITATION):
      const current = action.data.data;
      const newList = state.list
        .concat([action.data.data])
        .sort(timestampSorter);
      return {
        ...state,
        list: newList,
        currentMeditation: current
      };

    case sagaSearchSuccess(MEDITATION):
      return {
        ...state,
        currentMeditation: action.data.data,
        searching: false
      };
    case sagaUpdateSuccess(MEDITATION):
      let updatedMeditation = action.data.data;
      remove(state.list, x => x.id === updatedMeditation.id);
      state.list.push(updatedMeditation);
      state.list.sort(timestampSorter);
      return { ...state, currentMeditation: action.data.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/meditations.js